import { useState } from "react";
import { Link, NavLink } from "react-router";
import { MdContrast, MdDarkMode, MdLightMode } from "react-icons/md";
import scrollPageTo from "../utils/scrollPageTo";
import * as styles from "./NavbarDesktop.module.css";

function toggleThemeModal(e) {
  const themeModal =
    e.currentTarget.parentElement.querySelector(".theme-modal");
  themeModal.classList.toggle("hide-theme-modal");
}

export default function NavbarDesktop() {
  const [navThemeIcon, setNavThemeIcon] = useState(<MdDarkMode />);

  function changeTheme(e) {
    const root = document.documentElement;
    const themeOptions = document.querySelectorAll(".theme-option");
    const clickedThemeOption = e.target.closest(".theme-option");
    if (clickedThemeOption) {
      const classesOfClickedTheme = [...clickedThemeOption.classList];
      themeOptions.forEach((i) => i.classList.remove("active-theme"));
      clickedThemeOption.classList.add("active-theme");

      if (classesOfClickedTheme.includes("light")) {
        root.classList.add("light");
        root.classList.remove("dark");
        root.classList.remove("device");
        e.currentTarget.classList.add("hide-theme-modal");
        setNavThemeIcon(<MdLightMode />);
      }

      if (classesOfClickedTheme.includes("dark")) {
        root.classList.remove("light");
        root.classList.add("dark");
        root.classList.remove("device");
        e.currentTarget.classList.add("hide-theme-modal");
        setNavThemeIcon(<MdDarkMode />);
      }

      if (classesOfClickedTheme.includes("system")) {
        root.classList.remove("light");
        root.classList.remove("dark");
        root.classList.add("device");
        e.currentTarget.classList.add("hide-theme-modal");
        setNavThemeIcon(<MdContrast />);
      }
    }
  }

  return (
    <nav className={styles.nav}>
      <Link
        to="/"
        className={styles.navLogo}
        onClick={() => scrollPageTo("root")}
      >
        Oluwatobi
      </Link>
      <span className={styles.navRoutesAndTheme}>
        <span className={`${styles.routes} routes`}>
          <NavLink
            to="#projects"
            onClick={() => scrollPageTo("projects", "center")}
          >
            Projects
          </NavLink>
          <NavLink
            to="#publications"
            onClick={() => scrollPageTo("publications", "center")}
          >
            Publications
          </NavLink>
          <NavLink
            to="#contact"
            onClick={() => scrollPageTo("contact", "center")}
          >
            Contact
          </NavLink>
          {/* <Link to="/projects">Projects</Link>
          <Link to="/guest-posts">Guest Posts</Link>
          <Link to="/milestones">Milestones</Link> */}
          {/* <Link to="/resume.pdf">Resume</Link> */}
        </span>
        <span className={styles.theme}>
          <button
            type="button"
            title="Theme"
            className={`${styles.themeNavBtn} theme-nav-btn`}
            onClick={toggleThemeModal}
          >
            {navThemeIcon}
          </button>
          <div
            className={`${styles.themeModal} theme-modal hide-theme-modal`}
            onClick={changeTheme}
          >
            <button
              type="button"
              className={`${styles.themeOption} theme-option light`}
            >
              <MdLightMode />
              <span>Light</span>
            </button>
            <button
              type="button"
              className={`${styles.themeOption} theme-option dark active-theme`}
            >
              <MdDarkMode />
              <span>Dark</span>
            </button>
            <button
              type="button"
              className={`${styles.themeOption} theme-option system`}
            >
              <MdContrast />
              <span>System</span>
            </button>
          </div>
        </span>
      </span>
    </nav>
  );
}
